/* global axios */
import Auth from '../api/auth';
import {VUE_APP_API_FLOWS_BASE_URL } from '../../config/index'
import {VUE_APP_API_CAMPAINGS_BASE_URL} from '../../config/index'


const DEFAULT_API_VERSION = 'v1';

class ApiNotifai {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  // Devise token headers that Flow Manager (AWS and lab) validates in authenticate_request.
  // Same session Auth.getAuthData() as EditFlow.vue. URLs stay in gitignored config/index.js.
  // eslint-disable-next-line class-methods-use-this
  authHeaders() {
    const data = Auth.getAuthData() || {};
    return {
      'Content-Type': 'application/json',
      'access-token': data['access-token'],
      'token-type': data['token-type'] || 'Bearer',
      client: data.client,
      expiry: data.expiry,
      uid: data.uid,
    };
  }

  baseUrl() {
  let  url =VUE_APP_API_FLOWS_BASE_URL;
    /*
    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}/flow-manager`;
    }*/
     return url;
  }


  baseFlowsUrl() {
    let url =VUE_APP_API_FLOWS_BASE_URL;
     return url;
  }

  
  baseCampaingUrl() {
    let url = VUE_APP_API_CAMPAINGS_BASE_URL;
    return url;
   }
 

  get(params) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows",{
      params:params,
      headers: this.authHeaders(),
    });
  }


  getAll(params) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows",{
      params:params,
      headers: this.authHeaders(),
    });
  }


  show(id) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/1234/auth",{
      headers: this.authHeaders(),
    });
  }

  getTypeBotToken(){
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/1234/auth",{
      headers: this.authHeaders(),
    });
  }

  create(data) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows", data, {
      headers: this.authHeaders(),
    });
  }


  clone(data) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/clone", data, {
      headers: this.authHeaders(),
    });
  }

  publish(flowId) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/"+flowId+"/publish",{status:1}, {
      headers: this.authHeaders(),
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: this.authHeaders(),
    });
  }

  delete(flowId) {
    return axios.delete(this.baseFlowsUrl()+`/accounts/${this.accountIdFromRoute}/flow-manager/flows/${flowId}`, {
      headers: this.authHeaders(),
    });
  }
}

export default ApiNotifai;
